import { TZDate } from '@date-fns/tz';

export const SCHEDULED_DELIVERY_DATE_TIME_ZONE = 'UTC';

export const SCHEDULED_DELIVERY_DATE_FORMAT = 'EEE, MMM d';

export const getScheduledDeliveryDefaultDate = () => TZDate.tz(SCHEDULED_DELIVERY_DATE_TIME_ZONE);
